export default __webpack_public_path__ + "static/media/sendTo.e98f9137.svg";